import { useResource } from '@landsbankinn/l16n';
import {
  BottomButtons,
  Button,
  Col,
  ListItem,
  RichButton,
  TrashIcon24,
  UnorderedList,
} from '@landsbankinn/ui-kit';
import { type AppHubUser } from 'src/services/AppHubService';
import { res } from './AppLoginUsers.res';

type AppLoginUsersProps = {
  isMobile?: boolean;
  users: AppHubUser[];
  onAuthenticateUser: (user: AppHubUser) => void;
  onRevokeUser: (user: AppHubUser) => void;
  onQR: () => void;
};

export function AppLoginUsers({
  isMobile,
  users,
  onAuthenticateUser,
  onRevokeUser,
  onQR,
}: AppLoginUsersProps) {
  const { r } = useResource();

  return (
    <Col minHeight="429" paddingTop="28">
      <UnorderedList
        grow={!isMobile ? '1' : '0'}
        marginBottom={isMobile ? '64' : undefined}
      >
        {users.map((user) => (
          <ListItem
            key={user.userName}
            mainAxisAlignment="space between"
            crossAxisAlignment="center"
            direction="row"
            paddingBottom="19"
          >
            <RichButton
              instrumentAs="select_known_user"
              actionButtonAriaLabel="Delete user"
              actionButtonIcon={<TrashIcon24 color="blue font" />}
              onClickActionButton={() => onRevokeUser(user)}
              borderBottom="transparent"
              condense
              onClick={() => onAuthenticateUser(user)}
              label={user.name}
            />
          </ListItem>
        ))}
      </UnorderedList>
      <BottomButtons
        paddingBottom="0"
        paddingLeft="0"
        paddingRight="0"
        maxWidth="100%"
        grow="0"
      >
        <Button
          instrumentAs="select_another_user"
          variant="primary"
          width="100%"
          onClick={onQR}
        >
          {r(res.loginOtherUser)}
        </Button>
      </BottomButtons>
    </Col>
  );
}
